<template>
  <main>
    <SmartHomeSection />
  </main>
</template>

<script>
import SmartHomeSection from '../components/SmartHomeSection.vue'

export default {
  name: 'SmartHomePage',
  components: {
    SmartHomeSection
  }
}
</script>
